import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'react-tooltip'
import 'react-loading-skeleton/dist/skeleton.css'
import axios from "axios";
import { getUserDetails } from "../Utility/AsyncStorage";

function Products() {
    var userDetails = getUserDetails();
    const [isFormVisible, setFormVisible] = useState(false);
    const [isDeleteVisible, setDeleteVisible] = useState(false);
    const [productDetail, setProductDetail] = useState({});
    const [productList, setProductList] = useState([])

    const ProductsListData = async () => {
        console.log("ProductsListData");
        try {
            let url = process.env.REACT_APP_BASE_URL + "/ws/listProductPart";
            let body = {
                comp_num: userDetails.comp_num,
            };
            console.log("body login", body);
            await axios
                .post(url, body, {
                    headers: {
                        authorization: `${userDetails.access_token}`,
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.statusCode === 0) {
                            // console.log("ProductsListData", response.data.list);
                            setProductList(response.data.list)
                        } 
                        else if(response.data.statusCode === 1){
                            setProductList(response.data.msg)
                        }
                        else {
                            console.log("ProductsListData", response.data.msg);
                        }
                    }
                })
                .catch((error) => {
                    console.log("ProductsListData", error);
                });
        } catch (error) {
            console.log("ProductsListData", error);
        }
    }

    const handleChange = (fieldName, value) => {
        setProductDetail((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };

    const addProductList = async () => {
        console.log("addProductList")
        try {
            let url = process.env.REACT_APP_BASE_URL + "/ws/productPartCruds";
            let body = {
                part_num: productDetail.id,
                comp_num: userDetails.comp_num,
                part: productDetail.part,
                time: productDetail.time
            };
            console.log("addProductList ", productDetail, body)
            await axios
                .post(url, body, {
                    headers: {
                        authorization: `${userDetails.access_token}`,
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.statusCode === 0) {
                            setFormVisible(false);
                            ProductsListData();
                        } else {
                            console.log("workStationListData", response.data.msg);
                            setFormVisible(false);
                        }
                    }
                })
                .catch((error) => {
                    console.log("workStationListData", error);
                });
        } catch (error) {
            console.log("workStationListData", error);
        }
        setFormVisible(false);
        setProductDetail({});
    }

    const editCardDetails = (item) => {
        console.log("edit", item)
        setFormVisible(true);
        setProductDetail(item)
    }

    const deleteProduct = async () => {
        console.log("deleteProduct", productDetail)
        try {
            let url = process.env.REACT_APP_BASE_URL + "/ws/productPartCruds";
            let body = {
                part_num: productDetail.id,
                comp_num: userDetails.comp_num,
                is_active: "N"
            };
            console.log("addProductList ", productDetail, body)
            await axios
                .post(url, body, {
                    headers: {
                        authorization: `${userDetails.access_token}`,
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.statusCode === 0) {
                            setFormVisible(false);
                            ProductsListData();
                        } else {
                            console.log("workStationListData", response.data.msg);
                            setFormVisible(false);
                        }
                    }
                })
                .catch((error) => {
                    console.log("workStationListData", error);
                });
        } catch (error) {
            console.log("workStationListData", error);
        }
        setDeleteVisible(false);
        setProductDetail({});
    }


    useEffect(() => {
        ProductsListData();
    }, []);

    return (
        <div className="mainBlock">
            <div className="header">
                <div
                    className="inlineHead"
                    style={{ justifyContent: "space-between", alignItems: "center" }}
                >
                    <h2 className="header-h2">All Products</h2>
                    <div
                        className="addBlock"
                        onClick={() => {
                            setFormVisible(true);
                        }}
                    >
                        <h4>Add</h4>
                        <i class="fa-solid fa-clipboard-list"></i>
                    </div>
                </div>
            </div>

            <table className='workgroup-table'>
                <thead>
                    <tr style={{ height: "40px", backgroundColor: "#f9f9f9", textAlign: "left" }}>
                        <th style={{ borderRadius: "10px 0 0 10px", marginLeft: "10px" }}>Name</th>
                        <th>Estimantes Time (in sec)</th>
                        <th style={{ borderRadius: "0 10px 10px 0", textAlign: "center" }} >Action</th>
                    </tr>
                </thead>
                {Object.keys(productList).length === 0 ?
                    <tr>
                        <td><Skeleton count={5} /></td>
                        <td><Skeleton count={5} /></td>
                        <td><Skeleton count={5} /></td>
                    </tr> :
                    (typeof(productList) == "object" ? 
                    <tbody>
                        {productList.map((item, index) => (
                            <tr key={index}>
                                <td>{item.part}</td>
                                <td>{item.time}</td>
                                <td style={{ padding: "8px", textAlign: "center" }}>
                                    <i
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Edit"
                                        style={{ margin: "5px" }}
                                        class="fa-regular fa-pen-to-square"
                                        onClick={() => editCardDetails(item)} //edit
                                    ></i>
                                    <i
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Delete"
                                        style={{ margin: "5px" }}
                                        class="fa-regular fa-trash-can"
                                        onClick={() => {
                                            setDeleteVisible(true);
                                            setProductDetail({ id: item.id }); //delete work group
                                        }}
                                    ></i>
                                    <Tooltip id="my-tooltip" />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    :
                    <h2>No product added</h2> 
                    )
                }
            </table>

            {isFormVisible && (
                <div className="overlay">
                    <div className="form-box">
                        <h2>
                            {productDetail.hasOwnProperty("id")
                                ? "Edit Product Detail"
                                : "Add Product Detail"}
                        </h2>
                        <div>
                            <div className="input-group">
                                <label htmlFor="part">Product Name</label>
                                <input
                                    type="text"
                                    id="part"
                                    name="part"
                                    value={productDetail.part}
                                    onChange={(e) => handleChange("part", e.target.value)}
                                />
                            </div>
                            <div className="input-group">
                                <label htmlFor="time">Time (in min)</label>
                                <input
                                    type="number"
                                    id="time"
                                    min="1"
                                    step="10"
                                    name="time"
                                    value={productDetail.time}
                                    onChange={(e) => handleChange("time", e.target.value)}
                                />
                            </div>
                            <div style={{ justifyContent: "flex-end" }} className="inline">
                                <div
                                    className="submit-button"
                                    onClick={() => {
                                        setFormVisible(false);
                                        setProductDetail({});
                                    }}
                                >
                                    Back
                                </div>
                                <div className="submit-button" onClick={addProductList}>
                                    Submit
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isDeleteVisible && (
                <div className="overlay">
                    <div className="form-box">
                        <h2>Do you want to delete Workstation ? </h2>
                        {/* <p>Do you accept?</p> */}
                        <hr></hr>
                        <div>
                            <div style={{ justifyContent: "flex-end" }} className="inline">
                                <div
                                    className="submit-button"
                                    onClick={() => {
                                        setDeleteVisible(false);
                                        setProductDetail({});
                                    }}
                                >
                                    No
                                </div>
                                <div
                                    className="submit-button"
                                    onClick={() => {
                                        deleteProduct();
                                    }}
                                >
                                    Yes
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Products